// 引入js-cookie库
import Cookies from 'js-cookie'

export default {
  // 设置cookie
  setCookie(name, value, expireDays) {
    Cookies.set(name, value, { expires: expireDays })
  },
  // 获取cookie
  getCookie(name) {
    return Cookies.get(name)
  },
  // 删除cookie
  removeCookie(name) {
    Cookies.remove(name)
  }
}


// WEBPACK FOOTER //
// ./src/utils/cookie.js